import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-hamburger-button',
  templateUrl: './hamburger-button.component.html',
  styleUrls: ['./hamburger-button.component.css']
})
export class HamburgerButtonComponent implements OnInit {

  @Output() clicked = new EventEmitter();

  @Input() isLight = true;

  constructor() { }

  ngOnInit() {
  }

  getBackground(): string {

    if (this.isLight === true) {
      return 'blackBg';
    }

    return 'whiteBg';
  }

  onClicked() {
    if (this.clicked) {
      this.clicked.emit();
    }
  }

}
